import VideoThumbnailCard from '../../../../v2/components/VideoThumbnailCard';
import TRC_FILE_TYPE from '../../../constants/trcFileType';
import TRC_PAGE_CATEGORIES from '../../../constants/trcCategories';
import TRCPageLikeCard from '@/TRC/components/pageLikeCard';
import TRC_CONTENT from '@/constants/trcContentType';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';

const isProgressiveLessonPlan = content =>
	content.categoryDetails?.some(cat => cat._id === 'studio-lesson-plan');

const ResourcesGrid = ({ contents }) => {

	return (
		<div className="c-video_list">
			<div
				className="row m-0"
			>
				{contents?.map(content => {
					const route = isProgressiveLessonPlan(content)
						? TRC_ROUTES.PROGRESSIVE_LESSON_PLANS
						: content.fileType === TRC_FILE_TYPE.PDF
						? TRC_ROUTES.RESOURCES
						: TRC_ROUTES.VIDEOS;
					return (
						<div key={content._id || content?.title} className="mb-2" >
							<VideoThumbnailCard
								content={content}
								route={route.toLowerCase()}
								showSaveButton={false}
								showAddToPlaylist={false}
								type={TRC_CONTENT.TRC}
								customStyles={{ width: '100%', aspectRatio: '16/9' }}
							/>

						</div>
					)
				})}
			</div>
		</div>
	);
};

export default ResourcesGrid;
